<template>
   <div>
      <Navbar style="margin-left: 0" />
      <div class="cache-search-wrapper">
         <div class="search-wrapper">
            <div class="tab-wrapper">
               <div class="tab-header">
                  <div class="tab-item" :class="{ active: !isRebookMode }" @click="switchToSearchMode">
                     <span>{{ $t('hotelCacheSearch_tabSearch') }}</span>
                  </div>
                  <div class="tab-item" :class="{ active: isRebookMode }" @click="switchToRebookMode">
                     <span>{{ $t('hotelCacheSearch_tabRebook') }}</span>
                  </div>
               </div>
            </div>
            <div class="search-inline-wrapper">
               <div class="search-input">
                  <div class="checkbox" v-if="!isRebookMode">
                     <UICheckBox v-model="checked" :label="$t('hotelCacheSearch_lblMultiHotelSelect')" :hotel="true" />
                  </div>
                  <div class="auto-complete" v-if="!isRebookMode">
                     <SearchAutocomplete @update-to-destination="handlerUpdateDestination" :label="$t('hotelSearch_lblDestination')" />
                  </div>
                  <div class="rebook-inputs" v-if="isRebookMode">
                     <SearchAutocomplete @update-to-destination="handlerUpdateRebookHotel" :label="$t('hotelSearch_lblDestination')" :filterHotelsOnly="true" />
                     <UIInput label="Original Voucher ID" placeholder="Original Voucher ID" v-model="originalVoucherId" type="number" />
                  </div>
               </div>
               <div class="search-input-date">
                  <label class="date-label">{{ $t('hotelSearch_lblDate') }}</label>
                  <GtsDateRangePicker @update-to-date="handlerUpdateDate" calendarType="default" ref="hotelSearchDateRangePicker" />
               </div>
               <div class="search-input-guest">
                  <SearchGuestComponent @update-to-rooms="handlerUpdateRooms" ref="searchGuest" :label="$t('hotelSearch_lblGuest')" />
               </div>
               <div class="search-input-nationality">
                  <UISelectBox id="select_customerGender" :label="$t('hotelSearch_lblNationality')" :options="CountryList" allow-search v-model="hiddenNationalIdentity.code" />
               </div>
               <div class="search-input-currency" v-if="isRebookMode">
                  <UISelectBox id="select_currency" label="Currency" :options="currencyOptions" v-model="selectedCurrency" />
               </div>
               <div class="search-input-btn">
                  <UIButton className="hotel" :text="$t('common_search')" @click.native="handlerSearchHotel" />
               </div>
            </div>
            <div class="search-info-box">
               <p><i></i>{{ $t("hotelCacheSearch_lblSearchInfo") }}</p>
            </div>
         </div>
         <SearchResultDebugger
            v-if="isResultDebugger"
            :duration="searchResultTime"
            :searchListCount="responseData.hotels.length"
            :channels="this.responseData.channels"
            :channelCount="channelMatchCount"
            :availabilityUuid="this.availabilityUuid" />
         <div class="main-wrapper" v-if="isSearchResult">
            <div class="content-wrapper">
               <div class="hotelcard-wrapper" v-for="(hotel, index) in responseData.hotels" :key="index">
                  <div class="hotel-info-wrapper">
                     <div class="card-wrapper">
                        <img src="@/assets/images/room-no-photo.svg" />
                        <div class="hotelInfo">
                           <span class="hotelName">{{ hotel.name }}</span>
                        </div>
                     </div>
                     <div class="button-wrapper">
                        <div class="see-rooms">
                           <UIButton className="default" :notRounded="true" :text="$t('hotelCard_btnSearchRoom').toUpperCase()" @click.native="handlerSelectRoom(index)" />
                        </div>
                     </div>
                  </div>
                  <div class="divider" v-if="roomDetailSelected[index]"></div>
                  <div v-if="roomDetailSelected[index]">
                     <div class="room-card-wrapper" v-for="(rooms, keys) in responseData.hotels[index].roomGroups" :key="keys">
                        <div class="room-card-container">
                           <div class="room-wrapper-header">
                              <span class="room-count">{{ keys }}.{{ $t("hotelCard_room") }}</span>
                              <span class="room-capacity"
                                 >( {{ searchQuery.rooms[keys - 1].adults }} {{ $t("common_adult") }}
                                 <span v-if="searchQuery.rooms[keys - 1].children != 0"> {{ searchQuery.rooms[keys - 1].children }} {{ $t("common_child") }} </span>
                                 )
                              </span>
                           </div>
                           <div v-for="(room, roomIndex) in rooms.rooms" :key="roomIndex">
                              <div class="room-card" :class="!isRoomInBasket(room, keys) ? '' : 'selected'">
                                 <div class="room-card-color"></div>
                                 <div class="room-image">
                                    <img src="@/assets/images/room-no-photo.svg" />
                                 </div>
                                 <div class="room-name-container">
                                    <span class="room-Name">{{ room.name }}</span>
                                    <span class="room-board-Name">{{ room.boardName }}</span>
                                 </div>
                                 <div class="debugger-container">
                                    <CacheRoomCardDebugger
                                       :debuggerData="room.identifier"
                                       :isCacheData="isCacheData"
                                       :cancellationPolicy="room.cancellationPolicies"
                                       :providerName="getProviderNameByChannelId(room.channelId)"
                                       v-if="isDebugger"></CacheRoomCardDebugger>
                                 </div>

                                 <div class="price-container">
                                    <div class="addon-badge" v-if="room?.addOns?.length != 0">
                                       <span>{{ $t("hotelCacheSearch_addOn") }}</span>
                                    </div>
                                    <div class="refund-badge">
                                       <UIInfoBadge
                                          :className="'EHtlRefundType'"
                                          :modifier="room.refundable == true ? '--refundable' : room.refundable == false ? '--nonrefundable' : ''"
                                          :text="`${$options.filters.EHtlRefundType(room.refundable ? 1 : 2)}`" />
                                    </div>
                                    <div class="price">
                                       <span>{{ room.price.amount | price(currency) }} </span>
                                    </div>
                                    <div class="button-wrapper" v-if="!checkedStatus">
                                       <UIButton className="default__outline" icon="add-leg" rounded="true" @click.native="handlerAddBasket(room, keys, index)" v-if="!isRoomInBasket(room, keys)" />
                                       <UIButton className="default" icon="gts-icon icon-error" rounded="true" @click.native="handlerAddBasket(room, keys)" v-else />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="basket-area" v-if="showBasket">
               <div class="basket-content-wrapper">
                  <div class="basket-header">
                     <div v-for="(room, index) in basket.rooms" :key="index">
                        <span> {{ room.name }} </span>
                        <div v-if="room?.addOns?.length != 0">
                           <div class="basket-addon-wrapper" v-for="(addon, addonIndex) in room.addOns" :key="addonIndex">
                              <span class="addon-info">{{ addon.title }}</span>
                           </div>
                        </div>
                     </div>
                     <div class="delete-btn" @click="clearBasket">
                        <i class="gts-icon icon-hotel-empty-basket icon-sm"></i>
                     </div>
                  </div>
                  <div class="divider"></div>
                  <div class="basket-content">
                     <span>{{ basket.roomDetails }}</span>
                     <span class="room-subtitle">
                        {{ basket.roomSubtitle }}
                        <div class="price">
                           <span>{{ $t("hotelBasket_lblRoomPrice") }}</span>
                           <span class="price">{{ basket.totalPrice | price(currency) }} </span>
                        </div>
                     </span>
                  </div>
                  <div class="basket-footer" v-if="searchQuery.rooms.length == basket.rooms.length">
                     <UIButton className="light" :text="`${basket.totalPrice} `" @click.native="checkoutMode" />
                  </div>
               </div>
            </div>
         </div>
      </div>
      <HotelCacheCheckoutModal
         v-if="isCheckout"
         @close="isCheckout = false"
         :availabilityUuid="availabilityUuid"
         :bookingUuid="bookingUuid"
         :roomInfo="roomInfoDataArr"
         :totalPrice="totalPrice"
         :cancellationPolicies="cancellationPolicies"
         :hotelRules="hotelRules"
         :isRebookMode="isRebookMode"
         :originalVoucherId="originalVoucherId" />
      <UIModalDetail :modalSize="'auto'" v-show="showModal" :noBorder="true" :hasSlot="true" @close-modal="showModal = false">
         <div class="detail-modal-wrapper">
            <div id="modal-title">
               <span>{{ $t("hotelCacheSearch_lblSelectedHotels") }}</span>
            </div>
            <div class="hotel-stack-warning-text" v-if="hotelStack.length == 0">
               <span>{{ $t("hotelCacheSearch_lblHotelNotSelectedWarning") }}</span>
            </div>
            <div v-for="(hotels, index) in hotelStack" :key="index">
               <div class="stack-hotels">
                  <div class="is-in-search" v-if="hotelSearchResultIdHolder.length == 0"></div>
                  <div :class="hotelSearchResultIdHolder.includes(hotels.id) ? 'is-in-search inSearch' : 'is-in-search NotinSearch'" v-else></div>
                  <div class="hotelname">
                     <span>{{ hotelStack[index].name }}</span>
                  </div>
               </div>
            </div>
         </div>
      </UIModalDetail>
      <div class="multi-holder-holder" v-if="checked && !hotelStack.length < 2" @click="showStackDetail()">
         <div class="selected-wrapper">{{ hotelStack.length }}</div>
      </div>
   </div>
</template>

<script>
import SearchAutocomplete from "@/components/structural/hotel/common/SearchAutocomplete.vue";
import GtsDateRangePicker from "@/components/utils/GtsDateRangePicker.vue";
import SearchGuestComponent from "@/components/structural/hotel/common/SearchGuest.vue";
import UIInfoBadge from "@/components/unitary/InfoBadge.vue";
import moment from "moment";
import { hotelService } from "@/service/index.js";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import Popup from "@/gts-popup.js";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIModalDetail from "@/components/unitary/form2/UIModal.vue";
import UICheckBox from "@/components/unitary/form2/UICheckBox.vue";
import UIInput from "@/components/unitary/form2/UIInput.vue";
import CacheRoomCardDebugger from "@/components/structural/hotel/search/CacheRoomCardDebugger.vue";
import HotelCacheCheckoutModal from "./HotelCacheCheckoutModal.vue";
import SearchResultDebugger from "@/components/structural/hotel/search/SearchResultDebugger.vue";

export default {
   name: "HotelCacheSearch",
   components: {
      SearchAutocomplete,
      GtsDateRangePicker,
      SearchGuestComponent,
      UIButton,
      UIInfoBadge,
      Navbar,
      UISelectBox,
      CacheRoomCardDebugger,
      UICheckBox,
      UIInput,
      UIModalDetail,
      HotelCacheCheckoutModal,
      SearchResultDebugger,
   },
   data() {
      return {
         cancellationPolicies: [],
         hotelRules: "",
         roomInfoDataArr: [],
         destination: {},
         searchQuery: {
            hotelIds: [],
            checkinDate: "",
            checkoutDate: "",
            rooms: "",
            customerNationality: "DE",
         },
         hotelStack: [],
         hotelSearchResultIdHolder: [],
         isSearchResult: false,
         responseData: {},
         roomDetailSelected: {},
         hiddenNationalIdentity: {
            code: "DE",
            nameTr: "Almanya",
            nameEn: "Germany",
            nameDe: "Deutschland",
            phoneCode: "+49",
         },
         basket: {
            rooms: [],
         },
         currency: "",
         showBasket: false,
         isDebugger: false,
         isCacheData: false,
         checked: false,
         checkedStatus: false,
         showModal: false,
         isCheckout: false,
         availabilityUuid: "",
         bookingUuid: "",
         totalPrice: "",
         isResultDebugger: false,
         searchResultTime: 0,
         isRebookMode: false,
         originalVoucherId: null,
         rebookHotelId: null,
         selectedCurrency: "EUR",
         currencyOptions: [
            { name: "EUR", value: "EUR" },
            { name: "USD", value: "USD" },
            { name: "GBP", value: "GBP" },
            { name: "TRY", value: "TRY" },
         ],
      };
   },
   computed: {
      channelMatchCount() {
         let channelCount = {};

         if (!this.responseData.hotels || !this.responseData.channels) {
            return channelCount;
         }

         this.responseData.hotels.forEach((hotel) => {
            let checkedChannels = new Set();
            Object.values(hotel.roomGroups || {}).forEach((roomGroup) => {
               Object.values(roomGroup.rooms || {}).forEach((room) => {
                  let channelId = room.channelId;
                  if (this.responseData.channels[channelId] && !checkedChannels.has(channelId)) {
                     channelCount[channelId] = (channelCount[channelId] || 0) + 1;
                     checkedChannels.add(channelId);
                  }
               });
            });
         });

         return channelCount;
      },
      CountryList() {
         const self = this;
         //mapping countrylist for select array [tr]
         let activeLanguage = self.$store.state.user.user.language;

         let selectorStr = "";
         switch (activeLanguage) {
            case 1:
               selectorStr = "Tr";
               break;

            case 2:
               selectorStr = "En";
               break;

            case 3:
               selectorStr = "De";
               break;

            default:
               selectorStr = "En";
               break;
         }

         return self.$store.state.app.countryList.map((data) => {
            var obj = {
               name: data[`name${selectorStr}`],
               value: data.code.toUpperCase(),
               icon: data.code,
            };
            return obj;
         });
      },
   },
   created() {
      document.body.addEventListener("keydown", (event) => {
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 80) {
            this.isDebugger = !this.isDebugger;
         }
         if (held && event.keyCode == 84) {
            this.isResultDebugger = !this.isResultDebugger;
         }
      });
   },
   methods: {
      switchToSearchMode() {
         this.isRebookMode = false;
      },
      switchToRebookMode() {
         this.isRebookMode = true;
      },
      getProviderNameByChannelId(channelId) {
         if (!this.responseData.channels || typeof this.responseData.channels !== "object") {
            return null;
         }

         const channel = this.responseData.channels[channelId];
         if (channel && channel.providerName) {
            return channel.providerName;
         }

         return null;
      },
      checkoutMode() {
         const roomsData = this.basket.rooms;
         const rooms = {};

         roomsData.forEach((room) => {
            rooms[room.index] = room.identifier;
         });

         this.$store.commit("app/setIsProgressGifActive", true);

         // MIZE Rebook Mode - Use MIZE Check Availability
         if (this.isRebookMode) {
            const query = {
               originalVoucherId: Number(this.originalVoucherId),
               availabilityUuid: this.availabilityUuid,
               hotelId: Number(this.rebookHotelId),
               rooms: rooms,
            };

            hotelService
               .hotelMizeRebookCheckAvailability(query)
               .then((res) => {
                  if (!res.success) {
                     this.$store.commit("app/setIsProgressGifActive", false);
                     this.isCheckout = false;
                     Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopupToCheckout"), this.$i18n.t("HotelCacheSearch_WarningPopupTopInfo"));
                  } else {
                     this.totalPrice = res.totalPrice;
                     this.roomInfoDataArr = res.rooms.map((room) => ({
                        ...room,
                        checkinDate: this.searchQuery.checkinDate,
                        checkoutDate: this.searchQuery.checkoutDate,
                        boardName: res.boardName,
                        adult: Array.from({ length: room.adult }, () => ({
                           type: 1,
                           gender: 1,
                           name: "",
                           surname: "",
                           birthdate: "1971-01-01",
                        })),
                        children: Array.from({ length: room.children }, (child, childIndex) => ({
                           type: 2,
                           gender: 1,
                           name: "",
                           surname: "",
                           birthdate: this.setDefaultBirthdate(room.childrenAges[childIndex].max - room.childrenAges[childIndex].min),
                        })),
                     }));
                     this.bookingUuid = res.bookingUuid;
                     this.cancellationPolicies = res.cancellationPolicies;
                     this.hotelRules = res.hotelRules || "";

                     this.$store.commit("app/setIsProgressGifActive", false);
                     this.isCheckout = true;
                  }
               })
               .catch((error) => {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  Popup.error(this.$i18n.t("HotelCacheSearch_RebookCheckAvailabilityFailed"), error.message || this.$i18n.t("HotelCacheSearch_RebookCheckAvailabilityFailedContent"));
               });
         }
         // Normal Mode - Use Normal Check Availability
         else {
            const query = {
               availabilityUuid: this.responseData.availabilityUuid,
               hotelId: this.basket.rooms[0].id,
               rooms: rooms,
            };

            hotelService.hotelCacheCheckAvailability(query).then((res) => {
               if (!res.success) {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  this.isCheckout = false;
                  Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopupToCheckout"), this.$i18n.t("HotelCacheSearch_WarningPopupTopInfo"));
               } else {
                  this.totalPrice = res.totalPrice;
                  this.roomInfoDataArr = res.rooms.map((room) => ({
                     ...room,
                     checkinDate: this.searchQuery.checkinDate,
                     checkoutDate: this.searchQuery.checkoutDate,
                     boardName: res.boardName,
                     adult: Array.from({ length: room.adult }, () => ({
                        type: 1,
                        gender: 1,
                        name: "",
                        surname: "",
                        birthdate: "1971-01-01",
                     })),
                     children: Array.from({ length: room.children }, (child, childIndex) => ({
                        type: 2,
                        gender: 1,
                        name: "",
                        surname: "",
                        birthdate: this.setDefaultBirthdate(room.childrenAges[childIndex].max - room.childrenAges[childIndex].min),
                     })),
                  }));
                  this.availabilityUuid = this.responseData.availabilityUuid;
                  this.bookingUuid = res.bookingUuid;
                  this.cancellationPolicies = res.cancellationPolicies;
                  this.hotelRules = res.hotelRules || "";

                  this.$store.commit("app/setIsProgressGifActive", false);
                  this.isCheckout = true;
               }
            });
         }
      },
      setDefaultBirthdate(childAge) {
         const today = moment();
         const birthDate = today.clone().subtract(childAge, "years");
         return birthDate.format("YYYY-MM-DD");
      },
      showStackDetail() {
         this.showModal = !this.showModal;
      },

      isRoomInBasket(room, index) {
         return this.basket.rooms.some((selectedRoom) => selectedRoom.index === index && selectedRoom.identifier === room.identifier);
      },
      clearBasket() {
         this.showBasket = false;
         this.basket = {
            rooms: [],
         };
      },
      handlerAddBasket(room, index, hotelIndex) {
         let selectedRooms = this.basket.rooms || [];
         let roomSelections = this.roomSelections || [];

         if (!roomSelections[index]) {
            roomSelections[index] = { selectedRoomIdentifier: null };
         }
         selectedRooms.push({
            id: this.responseData.hotels[hotelIndex].id,
            hotelIndex: hotelIndex,
            index: index,
            name: room.name,
            price: room.price,
            identifier: room.identifier,
            boardName: room.boardName,
            addOns: room.addOns,
         });

         if (roomSelections[index].selectedRoomIdentifier && roomSelections[index].selectedRoomIdentifier !== room.identifier) {
            selectedRooms = selectedRooms.filter((selectedRoom) => selectedRoom.identifier !== roomSelections[index].selectedRoomIdentifier);
         }

         if (roomSelections[index].selectedRoomIdentifier === room.identifier) {
            selectedRooms = selectedRooms.filter((selectedRoom) => selectedRoom.identifier !== room.identifier);
            roomSelections[index].selectedRoomIdentifier = null;
         } else {
            roomSelections[index].selectedRoomIdentifier = room.identifier;
         }

         this.basket.rooms = selectedRooms;
         this.roomSelections = roomSelections;
         this.basket.totalPrice = this.basket.rooms.reduce((total, room) => total + room.price.amount, 0);
         this.basket.totalPrice = this.$options.filters.price(this.basket.totalPrice, this.currency);
         this.showBasket = selectedRooms.length > 0;
      },
      handlerSearchHotel() {
         this.searchResultTime = 0;

         // MIZE Rebook Mode
         if (this.isRebookMode) {
            if (!this.originalVoucherId || !this.rebookHotelId) {
               Popup.warning(this.$i18n.t("HotelCacheSearch_RebookMissingInfo"), this.$i18n.t("HotelCacheSearch_RebookMissingInfoContent"));
               return;
            }

            this.isDebugger = false;
            this.basket = {
               rooms: [],
            };
            this.showBasket = false;
            this.$store.commit("app/setIsProgressGifActive", true);
            this.isSearchResult = false;

            const query = {
               originalVoucherId: Number(this.originalVoucherId),
               hotelId: Number(this.rebookHotelId),
               checkinDate: this.searchQuery.checkinDate,
               checkoutDate: this.searchQuery.checkoutDate,
               rooms: this.searchQuery.rooms,
               currency: this.selectedCurrency,
               nationality: this.hiddenNationalIdentity.code,
            };
            const startTime = performance.now();

            hotelService
               .hotelMizeRebookSearch(query)
               .then((res) => {
                  const endTime = performance.now();
                  const duration = ((endTime - startTime) / 1000).toFixed(4);

                  if (!res.success || !res.rooms || Object.keys(res.rooms).length === 0) {
                     this.$store.commit("app/setIsProgressGifActive", false);
                     Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopup"), this.$i18n.t("HotelCacheSearch_WarningPopupInfo"));
                  } else {
                     // Convert MIZE response to normal hotel search format
                     const roomGroups = {};
                     Object.values(res.rooms).forEach((room) => {
                        const roomIndex = room.roomIndex;
                        if (!roomGroups[roomIndex]) {
                           roomGroups[roomIndex] = {
                              rooms: {},
                           };
                        }
                        roomGroups[roomIndex].rooms[room.identifier] = {
                           identifier: room.identifier,
                           name: room.name,
                           boardName: room.boardName,
                           refundable: room.refundable,
                           cancellationPolicies: room.cancellationPolicies,
                           channelId: room.channelId,
                           price: {
                              amount: room.grossPrice?.parsedValue || room.grossPrice,
                              currency: room.currency,
                           },
                           addOns: [],
                        };
                     });

                     // Create normalized response data
                     this.responseData = {
                        availabilityUuid: res.availabilityUuid,
                        hotels: [
                           {
                              id: res.hotelId,
                              name: res.hotelName,
                              roomGroups: roomGroups,
                           },
                        ],
                        channels: {},
                     };

                     // Extract channel info
                     Object.values(res.rooms).forEach((room) => {
                        if (!this.responseData.channels[room.channelId]) {
                           this.responseData.channels[room.channelId] = {
                              providerName: room.channelName,
                           };
                        }
                     });

                     this.availabilityUuid = res.availabilityUuid;
                     this.currency = res.currency || Object.values(res.rooms)[0].currency;
                     this.$store.commit("app/setIsProgressGifActive", false);
                     this.isSearchResult = true;
                     this.checkedStatus = false;
                  }

                  this.searchResultTime = duration;
               })
               .catch((error) => {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  Popup.error(this.$i18n.t("HotelCacheSearch_RebookSearchFailed"), error.message || this.$i18n.t("HotelCacheSearch_RebookSearchFailedContent"));
               });
         }
         // Multi Hotel Select Mode
         else if (this.checked) {
            if (this.hotelStack.length == 0) {
               Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopupEmpty"), this.$i18n.t("HotelCacheSearch_WarningPopupEmptyInfo"));
               return;
            }
            this.isDebugger = false;
            this.basket = this.basket = {
               rooms: [],
            };
            (this.showBasket = false), this.$store.commit("app/setIsProgressGifActive", true);
            this.isSearchResult = false;

            const query = {
               hotelIds: this.searchQuery.hotelIds,
               checkinDate: this.searchQuery.checkinDate,
               checkoutDate: this.searchQuery.checkoutDate,
               rooms: this.searchQuery.rooms,
               customerNationality: this.hiddenNationalIdentity.code,
            };
            const startTime = performance.now();

            hotelService.hotelCacheSearch(query).then((res) => {
               const endTime = performance.now();
               const duration = ((endTime - startTime) / 1000).toFixed(4);

               if (res.hotels.length === 0) {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopup"), this.$i18n.t("HotelCacheSearch_WarningPopupInfo"));
               } else {
                  this.responseData = res;
                  this.availabilityUuid = res.availabilityUuid;
                  this.currency = res.hotels["0"].roomGroups["1"].rooms[Object.keys(res.hotels["0"].roomGroups["1"].rooms)[0]].price.currency;
                  this.$store.commit("app/setIsProgressGifActive", false);

                  if (this.responseData.hotels.length != this.hotelStack.length) {
                     Popup.warning(this.$i18n.t("HotelCacheSearch_MultiSelectWarningPopup"), this.$i18n.t("HotelCacheSearch_MultiSelectWarningPopupInfo"));
                  }
                  for (let index = 0; index < this.responseData.hotels.length; index++) {
                     this.hotelSearchResultIdHolder.push(this.responseData.hotels[index].id);
                  }
                  this.isSearchResult = true;
                  this.checkedStatus = this.checked;
               }

               this.searchResultTime = duration;
            });
         } else {
            this.isDebugger = false;
            this.basket = this.basket = {
               rooms: [],
            };
            (this.showBasket = false), this.$store.commit("app/setIsProgressGifActive", true);
            this.isSearchResult = false;

            if (this.destination.id == undefined) {
               Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopupEmpty"), this.$i18n.t("HotelCacheSearch_WarningPopupEmptyInfo"));
               return;
            }

            var query = {};

            this.searchQuery.hotelIds[0] = this.destination.id;
            if (this.destination.type == 1) {
               query = {
                  locationId: this.destination.id,
                  hotelIds: [],
                  checkinDate: this.searchQuery.checkinDate,
                  checkoutDate: this.searchQuery.checkoutDate,
                  rooms: this.searchQuery.rooms,
                  customerNationality: this.hiddenNationalIdentity.code,
               };
            } else {
               query = {
                  locationId: 0,
                  hotelIds: this.searchQuery.hotelIds,
                  checkinDate: this.searchQuery.checkinDate,
                  checkoutDate: this.searchQuery.checkoutDate,
                  rooms: this.searchQuery.rooms,
                  customerNationality: this.hiddenNationalIdentity.code,
               };
            }
            const startTime = performance.now();

            hotelService.hotelCacheSearch(query).then((res) => {
               const endTime = performance.now();
               const duration = ((endTime - startTime) / 1000).toFixed(4);
               if (res.hotels.length === 0) {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  Popup.warning(this.$i18n.t("HotelCacheSearch_WarningPopup"), this.$i18n.t("HotelCacheSearch_WarningPopupInfo"));
               } else {
                  this.responseData = res;
                  this.availabilityUuid = res.availabilityUuid;
                  this.currency = res.hotels["0"].roomGroups["1"].rooms[Object.keys(res.hotels["0"].roomGroups["1"].rooms)[0]].price.currency;
                  this.$store.commit("app/setIsProgressGifActive", false);
                  this.isSearchResult = true;
                  this.checkedStatus = this.checked;
               }
               this.searchResultTime = duration;
            });
         }
      },
      handlerSelectRoom(index) {
         this.$set(this.roomDetailSelected, index, !this.roomDetailSelected[index]);
      },
      handlerUpdateRooms(rooms) {
         this.searchQuery.rooms = rooms;
      },
      handlerUpdateDestination(destination) {
         this.destination = destination;
      },
      handlerUpdateRebookHotel(destination) {
         if (destination && destination.type === 2) {
            this.rebookHotelId = destination.id;
         }
      },
      handlerUpdateDate(dateRange) {
         this.searchQuery.checkinDate = moment(dateRange.startDate).format("YYYY-MM-DD");
         this.searchQuery.checkoutDate = moment(dateRange.endDate).format("YYYY-MM-DD");
      },
   },
   watch: {
      availabilityUuid(newVal) {
         this.isCacheData = newVal.includes("_");
      },
      destination(newValue) {
         if (this.checked && newValue.id != null) {
            if (!this.searchQuery.hotelIds.includes(newValue.id)) {
               this.searchQuery.hotelIds.push(newValue.id);
               this.hotelStack.push(newValue);
            }
         }
      },
      checked(newVal, oldVal) {
         this.searchQuery.hotelIds = [];

         if (newVal == false) {
            if (oldVal == true) {
               if (this.hotelStack.length != 0) {
                  Popup.warning(this.$i18n.t("HotelCacheSearch_WarningMultiSelectPopup"), this.$i18n.t("HotelCacheSearch_WarningMultiSelectInfo"), "", 4000);
               }
            }
            this.hotelStack = [];
            this.hotelSearchResultIdHolder = [];
         }

         // Disable Rebook mode if Multi Hotel Select is enabled
         if (newVal === true) {
            this.isRebookMode = false;
         }
      },
      isRebookMode(newVal) {
         // Disable Multi Hotel Select if Rebook mode is enabled
         if (newVal === true) {
            this.checked = false;
            this.hotelStack = [];
            this.hotelSearchResultIdHolder = [];
            this.searchQuery.hotelIds = [];
         }
      },
   },
};
</script>

<style scoped lang="scss">
#modal-title {
   display: flex;
   justify-content: center;
   span {
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 1rem;
   }
}
.cache-search-wrapper {
   padding: 0.5rem;
   max-width: 1600px;
   margin: 0 auto;

   .search-wrapper {
      background-color: var(--surface-level-1);
      //height: 145px;
      padding: 1rem;
      padding-bottom: 2rem;
      border-radius: 1rem;
      display: flex;
      flex-direction: column;

      .tab-wrapper {
         margin-bottom: 1rem;
         .tab-header {
            display: flex;
            border-bottom: 2px solid var(--gray-300);

            .tab-item {
               padding: 1rem 2rem;
               cursor: pointer;
               font-weight: 500;
               font-size: 16px;
               color: var(--gray-500);
               border-bottom: 3px solid transparent;
               margin-bottom: -2px;
               transition: all 0.3s ease;

               &:hover {
                  color: #363636;
               }

               &.active {
                  color: var(--product-hotel);
                  border-bottom-color: var(--product-hotel);
               }
            }
         }
      }

      .search-info-box {
         padding-left: 1.5rem;
         padding-top: 1.5rem;

         p {
            display: flex;
            i {
               background-image: url("data:image/svg+xml;base64,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");
               background-repeat: no-repeat;
               background-position: center center;
               background-size: contain;
               width: 20px;
               height: 20px;
               display: block;
               margin-right: 0.5rem;
            }
         }
      }
      .search-inline-wrapper {
         margin-top: 1rem;
         padding-inline: 1.5rem;
         display: flex;
         align-items: center;
         justify-content: space-between;
         .search-input {
            width: 30%;
            .auto-complete {
               margin-top: -1.2rem;
            }
            .checkbox {
               display: flex;
               justify-content: flex-end;
            }
            .rebook-inputs {
               display: flex;
               gap: 1rem;
            }
         }
         .search-input-date {
            width: 15%;
            margin-top: -0.5rem;

            .date-label {
               display: block;
               margin-bottom: 0.5rem;
               font-size: 14px;
               font-weight: 500;
               color: var(--text-primary);
            }
         }
         .search-input-guest {
            margin-top: -0.5rem;
            width: 15%;
         }
         .search-input-nationality {
            margin-top: -0.5rem;
            width: 10%;
         }
         .search-input-currency {
            margin-top: -0.5rem;
            width: 10%;
         }
         .search-input-btn {
            margin-top: 1.5rem;
            width: 10%;
         }
      }
   }
   .main-wrapper {
      display: flex;
      justify-content: center;
      .basket-area {
         width: 15%;
         background: var(--primary);
         border-radius: 1rem;
         margin-top: 3rem;
         margin-right: 1rem;
         margin-bottom: 50%;
         height: fit-content;
         .basket-content-wrapper {
            display: flex;
            flex-direction: column;
            padding: 1.5rem;
            .basket-header {
               span {
                  font-size: 20px;
                  color: white;
                  font-weight: 600;
               }
               .delete-btn {
                  cursor: pointer;
                  display: flex;
                  justify-content: flex-end;
                  i:hover {
                     filter: brightness(1);
                     opacity: 0.6;
                     width: 22px !important;
                  }
               }
               .basket-addon-wrapper {
                  .addon-info {
                     color: var(--purple-400);
                  }
               }
            }
            .divider {
               margin-top: 1rem;
               background-image: linear-gradient(to right, var(--gray-200) 33%, var(--gray-0-alpha-90) 0%);
               background-position: left;
               background-size: 12px auto;
               background-repeat: repeat-x;
               display: inline-block;
               width: 100%;
               bottom: 7px;
               left: 1rem;
               right: 1rem;
               height: 2px;
            }
            .basket-content {
               padding-top: 1rem;
               display: flex;
               flex-direction: column;
               span {
                  font-size: 20px;
                  color: white;
                  font-weight: 600;
               }
               .room-subtitle {
                  padding-top: 1rem;
                  font-size: 15px;
                  color: var(--teal-400);
                  font-weight: 600;
               }
               .price {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  span {
                     margin-top: 0.5rem;
                     font-size: 16px;
                  }
                  .price {
                     color: var(--teal-400);
                     font-size: 20px;
                  }
               }
            }
            .basket-footer {
               display: flex;
               justify-content: center;
               padding-top: 1rem;
            }
         }
      }

      .content-wrapper {
         margin-top: 2rem;
         padding-left: 1rem;
         justify-content: center;
         width: 100%;
         padding-right: 2rem;
         .hotelcard-wrapper {
            background-color: var(--surface-level-1);
            border-radius: 1rem;
            height: auto;
            margin-top: 1rem;
            .hotel-info-wrapper {
               background-color: var(--surface-level-1);
               border-radius: 1rem;
               height: 150px;
               width: 100%;
               display: flex;
               justify-content: space-between;
               .gts-ribbon {
                  margin-top: 2.5rem;
                  width: 80px;
                  height: 112px;
                  background-image: url("data:image/svg+xml;base64,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");
               }
               .card-wrapper {
                  display: flex;
                  img {
                     width: 200px;
                     padding: 1rem;
                  }

                  .hotelInfo {
                     display: flex;
                     flex-direction: column;
                     padding-top: 1rem;
                     .hotelName {
                        font-size: 20px;
                        font-weight: 600;
                     }
                     .hotelLocation {
                        margin-top: 0.5rem;
                     }
                  }
               }
               .button-wrapper {
                  display: flex;
                  flex-direction: column;
                  min-width: 15%;
                  padding-top: 1rem;
                  height: 100%;
                  border-left: 1px solid var(--gray-300);
                  justify-content: center;
                  .gts-direct {
                     display: flex;
                     justify-content: center;
                     margin-top: 1rem;
                     width: 100%;
                  }
                  .price {
                     display: flex;
                     justify-content: center;
                     padding: 1rem;
                     span {
                        font-size: 24px;
                        font-weight: 600;
                     }
                  }
                  .see-rooms {
                     display: flex;
                     justify-content: center;
                     width: 80%;
                     margin-left: 10%;
                  }
               }
               padding-bottom: 1rem;
            }
            .divider {
               border-top: 1px solid var(--gray-300);
               width: 100%;
            }
            .room-card-wrapper {
               margin: 0 auto;
               padding: 2rem;
               border-radius: 0 0 1rem 1rem;
               .room-card-container {
                  border: 1px solid var(--gray-300);
                  border-radius: 1rem 1rem 0 0;
                  .room-wrapper-header {
                     display: flex;
                     justify-content: space-between;
                     background: var(--gray-200);
                     height: 3.5rem;
                     align-items: center;
                     padding: 1rem;
                     border-radius: 1rem 1rem 0 0;
                     .room-count {
                        font-weight: 600;
                     }
                     .room-capacity {
                        color: var(--gray-500);
                        font-weight: 500;
                     }
                  }
                  .room-card {
                     padding: 1rem;
                     display: flex;
                     margin: 1rem;
                     flex-direction: row;
                     background: var(--gray-100);
                     border-radius: 1rem;
                     &.selected {
                        border: 4px solid var(--blue-400);
                     }
                     .room-card-color {
                        min-width: 6px;
                        background: var(--blue-400);
                        float: left;
                        padding: 0;
                        margin-left: -1rem;
                        margin-right: 1rem;
                        border-radius: 0 1rem 1rem 0;
                     }
                     .room-image {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-width: 70px;
                     }
                     .debugger-container {
                        width: 100%;
                     }
                     .room-name-container {
                        display: flex;
                        flex-direction: column;
                        width: 70%;
                        .room-Name {
                           padding-left: 2rem;
                           font-size: 16px;
                           font-weight: 500;
                        }
                        .room-board-Name {
                           margin-top: 0.75rem;
                           padding-left: 2rem;
                           font-size: 13px;
                           font-weight: 400;
                        }
                     }
                     .price-container {
                        display: flex;
                        margin-left: 15%;
                        .refund-badge {
                           padding: 1rem;
                        }
                        .addon-badge {
                           display: flex;
                           align-items: center;
                           background: var(--purple-400);
                           //color: var(--gray-50);
                           color: var(--gray-0);
                           border-radius: 1.5rem 0.25rem;
                           height: 40px;
                           font-weight: 500;
                           padding: 0 1rem;
                           margin-top: 0.25rem;
                           width: max-content;
                        }
                        .price {
                           border-left: 1px solid var(--gray-300);
                           display: flex;
                           justify-content: center;
                           align-items: center;
                           width: 120px;
                           span {
                              font-weight: 500;
                              font-size: 20px;
                           }
                        }
                        .button-wrapper {
                           border-left: 1px solid var(--gray-300);
                           width: 100px;
                           display: flex;
                           justify-content: center;
                           align-items: center;

                           &::v-deep button {
                              background-color: var(--accent-primary);

                              i.icon-error {
                                 width: 16px !important;
                                 height: 16px !important;
                                 filter: brightness(100);
                              }
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
.detail-modal-wrapper {
   padding-top: 1rem;
   display: flex;
   flex-direction: column;
   .hotel-stack-warning-text {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      span {
         font-size: 20px;
         font-weight: 500;
      }
   }
   .stack-hotels {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      height: 5rem;
      width: auto;
      border: 1px solid var(--gray-400);
      background: var(--gray-100);
      align-items: center;
      margin-top: 0.75rem;
      border-radius: 12px;
   }
   .hotelname {
      padding: 0.5rem;
      margin-left: 0.25rem;
      font-weight: 500;
   }
   .is-in-search {
      min-width: 10px;
      height: 100%;
      background: gray;
      border-radius: 1rem 0rem 0rem 1rem;
      &.inSearch {
         background: green;
      }
      &.NotinSearch {
         background: red;
      }
   }
}
.multi-holder-holder {
   position: fixed;
   width: 5rem;
   height: 5rem;
   background: var(--product-hotel);
   bottom: 0;
   right: 0;
   margin-right: 2rem;
   margin-bottom: 2rem;
   border-radius: 100%;
   cursor: pointer;
   .selected-wrapper {
      display: flex;
      justify-content: center;
      text-align: center;
      margin-top: 0.5rem;
      font-size: 2.5rem;
      color: white;
   }
}

::v-deep .gts-date-range-input {
   background: #f2f5f7;
   border: 1px solid #e7eaed;
}
</style>
